import { isAddress } from 'web3-utils';

import { ContractsManager } from 'modules/core';
import { api, cacheTags } from 'modules/store';

const CHECK_TASK_SIGNATURE = 'checkTask(bytes)';
const PERFORM_TASK_SIGNATURE = 'performTask(bytes)';

export const { useLazyIsCompatibleContractQuery } = api.injectEndpoints({
  endpoints: build => ({
    isCompatibleContract: build.query<boolean, { contractAddress: string }>({
      queryFn: async ({ contractAddress }) => {
        if (!isAddress(contractAddress)) {
          return { data: false };
        }

        const sdk = await ContractsManager.getInstance();

        const [isCheckTask, isPerformTask] = await Promise.all([
          sdk.hasMethod(contractAddress, CHECK_TASK_SIGNATURE),
          sdk.hasMethod(contractAddress, PERFORM_TASK_SIGNATURE),
        ]);

        return { data: isCheckTask && isPerformTask };
      },
      providesTags: [cacheTags.taskData],
    }),
  }),
});
